// Develop: build idéntico a producción (optimizado, budgets) pero apuntando a la API de
// develop. apiUrl relativo A PROPÓSITO (no un dominio): docker-compose.develop.yml sirve el
// build de este panel y el backend de develop detrás del MISMO nginx/mismo origen (nginx
// proxea /api/** al container app-develop) — mismo patrón que el proxy.conf.mjs de dev, evita
// tener que fijar un dominio/IP del VPS acá y de paso elimina CORS (mismo origen). Ver
// deploy-develop.sh y docs/DEPLOY-VPS.md § Develop.
// RF05: publicApiKey es la clave de PRUEBAS (credlap.public.test-api-key en el backend de
// develop), no la real — el backend la resuelve como ApplicationMode.TEST por identidad de key.
// portfolioAdminUrl (ADR 0021 of credlap-architecture, section 5): PFA of develop, the same value
// CS develop has in PORTFOLIO_ADMIN_URL. Blank hides the Cobranzas area.
export const environment = {
  production: true,
  appVersion: '0.0.0',
  apiUrl: '/api/v1',
  publicApiKey: 'develop-public-test-api-key',
  portfolioAdminUrl: 'https://develop-portfolio.credlap.com',
  // Module 1 demo (owner, 2026-11-03): the menu lists only Clientes; null restores it.
  navOnlyPaths: ['/clientes', '/posibles-duplicados', '/cola-identidad', '/pedidos-baja'] as
    readonly string[] | null,
};
